import { AddMealForm } from '../components/AddMealForm';
import { Card } from '../components/Card';
import { MetricRow } from '../components/MetricRow';
import { ScoreRing } from '../components/ScoreRing';
import { useHealthData } from '../services/HealthDataContext';
import { getMetricSeries } from '../services/metrics';
import { formatTime } from '../services/labels';

const MEAL_TYPE_LABELS: Record<string, string> = {
  breakfast: 'Desayuno',
  lunch: 'Almuerzo',
  dinner: 'Cena',
  snack: 'Snack',
};

export function NutritionScreen() {
  const { today, todayKey, scores, baselines, historyByDate } = useHealthData();
  const caloriesSeries = getMetricSeries(historyByDate, 'nutritionCalories', todayKey, 14).map((p) => p.value);
  const proteinSeries = getMetricSeries(historyByDate, 'proteinIntake', todayKey, 14).map((p) => p.value);

  return (
    <div className="screen screen--nutrition">
      <div className="screen__score-header">
        <ScoreRing score={scores.nutritionScore} label="Nutricion" size={140} />
        <div className="screen__score-summary">
          <p className="screen__score-summary-title">{today.nutrition.calories} kcal</p>
          <p className="screen__score-summary-subtitle">{today.nutrition.protein} g de proteina</p>
        </div>
      </div>

      <Card title="Registrar alimento">
        <AddMealForm />
      </Card>

      <Card title="Macros de hoy" subtitle="Comparados con tu baseline personal">
        <div className="metric-grid">
          <MetricRow
            label="Calorias"
            value={String(today.nutrition.calories)}
            unit="kcal"
            baseline={baselines.metrics.nutritionCalories?.[14]}
            series={caloriesSeries}
          />
          <MetricRow
            label="Proteina"
            value={String(today.nutrition.protein)}
            unit="g"
            baseline={baselines.metrics.proteinIntake?.[30]}
            series={proteinSeries}
          />
          <MetricRow label="Carbohidratos" value={String(today.nutrition.carbs)} unit="g" hideBaseline />
          <MetricRow label="Grasas" value={String(today.nutrition.fat)} unit="g" hideBaseline />
          <MetricRow label="Fibra" value={String(today.nutrition.fiber)} unit="g" hideBaseline />
          <MetricRow label="Sodio" value={String(today.nutrition.sodium)} unit="mg" hideBaseline />
          <MetricRow label="Azucar" value={String(today.nutrition.sugar)} unit="g" hideBaseline />
        </div>
      </Card>

      <Card title="Comidas registradas">
        {today.nutrition.meals.length === 0 ? (
          <p className="empty-state">Sin comidas registradas hoy.</p>
        ) : (
          <ul className="meal-list">
            {today.nutrition.meals.map((meal) => (
              <li key={meal.id} className="meal-list__item">
                <div>
                  <p className="meal-list__name">{meal.name}</p>
                  <p className="meal-list__meta">
                    {MEAL_TYPE_LABELS[meal.mealType] ?? meal.mealType} · {formatTime(meal.time)}
                  </p>
                </div>
                <div className="meal-list__stats">
                  <span>{meal.calories} kcal</span>
                  <span>{meal.protein} g prot.</span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
